import React from 'react'
import { Breadcrumb } from 'hljd'
import { Flex } from 'hljd'
import cls from 'classnames'
import style from './style.module.less'

function View(props) {
  const { header, title, extra, children } = props

  const getHeader = header => {
    header = header || []
    return (
      <Breadcrumb>
        {header.map((item, index) => {
          const last = index === header.length - 1
          return (
            <Breadcrumb.Item
              className={cls(style['b-item'], {
                [style['b-item-last']]: last
              })}
            >
              {item}
            </Breadcrumb.Item>
          )
        })}
      </Breadcrumb>
    )
  }

  return (
    <Flex className={style.view} d="v">
      <Flex className={style.header} vc sp>
        <Flex d="v">
          <div className={style.breadcrumb}>{getHeader(header)}</div>
          <div className={style.title}>{title}</div>
        </Flex>

        {extra && <div className={style.extra}>{extra}</div>}
      </Flex>

      <div className={style.content}>{children}</div>
    </Flex>
  )
}

export default View
